/**
 * Shared catalog of available prebuilt mock exams.
 *
 * This is the SINGLE SOURCE OF TRUTH used by both:
 *   - MockTests.js  (/user/dashboard/mock)
 *   - TeacherDashboard.js (school teacher exam picker)
 *
 * To add a new exam:
 *   1. Add an entry here with the correct slug, examName, description, examUrl, and subjects.
 *   2. Add the corresponding route in client/src/App.js.
 *   3. Create the exam component in client/src/components/MockTests/Exams/.
 */
export const PREBUILT_EXAM_CATALOG = [
  {
    slug: 'utme',
    examName: 'UTME',
    description: 'Unified Tertiary Matriculation Examination Mock',
    examUrl: '/user/dashboard/mock/utme',
    duration: 23,
    passmark: 50,
    subjects: [
      'English Language', 'Mathematics', 'Physics', 'Chemistry', 'Biology',
      'Further Mathematics', 'Literature in English', 'Government', 'Economics',
      'Commerce', 'Financial Accounting', 'Geography', 'History',
      'Agricultural Science', 'Christian Religious Studies', 'Islamic Religious Studies',
      'Yoruba', 'Igbo', 'Hausa', 'French', 'Technical Drawing',
      'Fine Arts', 'Music', 'Home Economics', 'Physical Education', 'Civic Education',
    ],
  },
  {
    slug: 'wassce',
    examName: 'WASSCE',
    description: 'West African Senior School Certificate Examination Mock',
    examUrl: '/user/dashboard/mock/wassce',
    duration: 60,
    passmark: 50,
    subjects: [
      'English Language', 'Mathematics', 'Physics', 'Chemistry', 'Biology',
      'Further Mathematics', 'Literature in English', 'Government', 'Economics',
      'Commerce', 'Financial Accounting', 'Geography', 'History',
      'Agricultural Science', 'Christian Religious Studies', 'Islamic Religious Studies',
      'Yoruba', 'Igbo', 'Hausa', 'French', 'Technical Drawing',
      'Food & Nutrition', 'Visual Arts', 'Music', 'Physical Education',
    ],
  },
  {
    slug: 'ican',
    examName: 'ICAN',
    description: 'Institute of Chartered Accountants of Nigeria Mock Exams',
    examUrl: '/user/dashboard/mock/ican',
    duration: 180,
    passmark: 50,
    subjects: [
      'Financial Accounting', 'Management Accounting', 'Auditing & Assurance',
      'Business Finance', 'Corporate Reporting', 'Financial Management',
      'Advanced Taxation', 'Public Sector Accounting & Finance',
      'Management Information', 'Business Law',
    ],
  },
  {
    slug: 'ncs',
    examName: 'NCS',
    description: 'Nigeria Customs Service Recruitment CBT Mock',
    examUrl: '/user/dashboard/mock/ncs',
    duration: 45,
    passmark: 50,
    subjects: [
      'English Language / Verbal Reasoning', 'Mathematics / Quantitative Aptitude',
      'General Studies / Current Affairs', 'Customs Laws & Trade Policy',
      'Ports & Customs Procedures', 'Accounting & Finance Basics',
    ],
  },
  {
    slug: 'subeb',
    examName: 'SUBEB',
    description: 'States Universal Basic Education Board Recruitment CBT Mock',
    examUrl: '/user/dashboard/mock/subeb',
    duration: 45,
    passmark: 50,
    subjects: [
      'English Language', 'Mathematics', 'General Studies',
      'Current Affairs / Civic Knowledge', 'Pedagogy & Teaching Methods',
      'Child Development & Educational Psychology',
    ],
  },
  {
    slug: 'fcsc',
    examName: 'FCSC',
    description: 'Federal Civil Service Commission Recruitment CBT Mock',
    examUrl: '/user/dashboard/mock/fcsc',
    duration: 45,
    passmark: 50,
    subjects: [
      'English Language / Verbal Reasoning', 'Mathematics / Quantitative Aptitude',
      'General Studies', 'Current Affairs', 'Nigerian History & Government',
      'Civil Service Rules & Procedures',
    ],
  },
  {
    slug: 'trcn',
    examName: 'TRCN PQE',
    description: 'Teachers Registration Council of Nigeria PQE Mock',
    examUrl: '/user/dashboard/mock/trcn',
    duration: 60,
    passmark: 50,
    subjects: [
      'Foundations of Education', 'Educational Psychology',
      'Curriculum Studies & Methods', 'Educational Administration & Management',
      'Research Methods in Education', 'Tests, Measurement & Evaluation',
      'Guidance & Counselling',
    ],
  },
  {
    slug: 'nscdc',
    examName: 'NSCDC',
    description: 'Nigeria Security and Civil Defence Corps Recruitment CBT Mock',
    examUrl: '/user/dashboard/mock/nscdc',
    duration: 45,
    passmark: 50,
    subjects: [
      'English Language / Verbal Reasoning', 'Mathematics / Quantitative Aptitude',
      'General Studies / Current Affairs', 'Security & Civil Defence Act',
      'Nigerian Constitution & Government',
    ],
  },
  {
    slug: 'ffs',
    examName: 'Federal Fire Service',
    description: 'Federal Fire Service (Nigeria) Recruitment CBT Mock',
    examUrl: '/user/dashboard/mock/ffs',
    duration: 60,
    passmark: 50,
    subjects: [
      'English Language', 'Mathematics', 'General Studies / Current Affairs',
      'Fire Safety & Prevention', 'Basic Chemistry & Physics of Fire',
    ],
  },
  {
    slug: 'nis',
    examName: 'NIS',
    description: 'Nigeria Immigration Service Recruitment CBT Mock',
    examUrl: '/user/dashboard/mock/nis',
    duration: 45,
    passmark: 50,
    subjects: [
      'English Language / Verbal Reasoning', 'Mathematics / Quantitative Aptitude',
      'General Studies / Current Affairs', 'Immigration Laws & Border Control',
      'Nigerian Government & Constitution',
    ],
  },
];

